import React from 'react'
import PropTypes from 'prop-types'

const PersonAddIcon = (props) => {
  const { color = '#737373', classes = 'w-20' } = props
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={classes}
    >
      <path
        d="M9.75 6C9.75 4.3425 8.4075 3 6.75 3C5.0925 3 3.75 4.3425 3.75 6C3.75 7.6575 5.0925 9 6.75 9C8.4075 9 9.75 7.6575 9.75 6ZM8.25 6C8.25 6.825 7.575 7.5 6.75 7.5C5.925 7.5 5.25 6.825 5.25 6C5.25 5.175 5.925 4.5 6.75 4.5C7.575 4.5 8.25 5.175 8.25 6ZM0.75 13.5V15H12.75V13.5C12.75 11.505 8.7525 10.5 6.75 10.5C4.7475 10.5 0.75 11.505 0.75 13.5ZM2.25 13.5C2.4 12.9675 4.725 12 6.75 12C8.7675 12 11.085 12.96 11.25 13.5H2.25ZM15 11.25V9H17.25V7.5H15V5.25H13.5V7.5H11.25V9H13.5V11.25H15Z"
        fill={color}
      />
    </svg>
  )
}

PersonAddIcon.propTypes = {
  color: PropTypes.string,
  classes: PropTypes.string,
}

export default React.memo(PersonAddIcon)
